import { useMutation, useQueryClient } from '@tanstack/react-query'

import { UserPkg } from '@/api/user-package/types/UserPkg'
import { QUERY_KEYS } from '@/lib/queryKeys'

import { cancelShipment } from '../paymentsService'

export const useCancelShipment = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: cancelShipment,
    onSuccess: (_, packageId) => {
      queryClient.setQueriesData<UserPkg[]>({ queryKey: [QUERY_KEYS.USER_PACKAGES] }, old =>
        old?.map(p => (p.id === packageId ? { ...p, isPaid: false, hasRefunded: true } : p))
      )
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.USER_PACKAGES] })
    },
  })
}
